import {
  UpdateUserRequestDtoAccountType,
  UserListItemResponseDtoAccountType,
} from "@/spz-api/model";

export class UserAccountType {
  private _value: "admin" | "basic_user";
  private _labelKey: string;
  private _descriptionKey: string;
  private constructor(
    value: "admin" | "basic_user",
    labelKey: string,
    descriptionKey: string,
  ) {
    this._value = value;
    this._labelKey = labelKey;
    this._descriptionKey = descriptionKey;
  }

  static ADMIN = new UserAccountType(
    "admin",
    "user_account_type_admin",
    "user_account_type_admin_description",
  );
  static BASIC_USER = new UserAccountType(
    "basic_user",
    "user_account_type_basic_user",
    "user_account_type_basic_user_description",
  );

  static fromValue(value: string): UserAccountType {
    switch (value) {
      case "admin":
        return UserAccountType.ADMIN;
      case "basic_user":
        return UserAccountType.BASIC_USER;
      default:
        throw new Error(`Invalid UserAccountType value: ${value}`);
    }
  }

  static fromApi(value: UserListItemResponseDtoAccountType): UserAccountType {
    switch (value) {
      case UserListItemResponseDtoAccountType.admin:
        return UserAccountType.ADMIN;
      case UserListItemResponseDtoAccountType.basic_user:
        return UserAccountType.BASIC_USER;
    }
  }

  static toUpdateApi(value: UserAccountType): UpdateUserRequestDtoAccountType {
    switch (value) {
      case UserAccountType.ADMIN:
        return UpdateUserRequestDtoAccountType.admin;
      case UserAccountType.BASIC_USER:
        return UpdateUserRequestDtoAccountType.basic_user;
      default:
        throw new Error(`Invalid UserAccountType: ${value.value}`);
    }
  }

  static get values(): readonly UserAccountType[] {
    return [UserAccountType.ADMIN, UserAccountType.BASIC_USER];
  }

  static getOptions() {
    return UserAccountType.values.map((value) => ({
      value: value.value,
      labelKey: value.labelKey,
      descriptionKey: value.descriptionKey,
    }));
  }

  get value() {
    return this._value;
  }

  get labelKey() {
    return this._labelKey;
  }

  get descriptionKey() {
    return this._descriptionKey;
  }
}
